import styled from 'styled-components';

const LessonsContainer = styled.div`

`;

export {
  LessonsContainer
}